import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { Constants } from '../core/constants';
import { UserService } from '../core/user.service';

/** Matches the "Quarterly Metric Management" menu item: view or edit on permission 975. */
export const quarterlyMetricsGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  return userService.security$.pipe(
    take(1),
    map(() =>
      userService.hasPermissionKey(Constants.PermQuarterlyMetrics, Constants.PermLevel_VIEW) ||
      userService.hasPermissionKey(Constants.PermQuarterlyMetrics, Constants.PermLevel_EDIT)
        ? true
        : router.createUrlTree(['/'])
    )
  );
};
